import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface BackButtonProps {
  /** Custom path to navigate to. If not provided, uses browser history (-1) */
  to?: string;
  /** Custom text for the button. Defaults to "Back" */
  text?: string;
  /** Additional CSS classes */
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ 
  to, 
  text = "Back", 
  className = "" 
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center px-4 py-2 bg-white bg-opacity-20 backdrop-blur-md border border-white border-opacity-30 rounded-lg text-gray-700 hover:text-gray-900 hover:bg-opacity-30 font-medium text-sm transition-all duration-300 group shadow-lg hover:shadow-lg ${className}`}
    >
      <ArrowLeft className="h-4 w-4 mr-2 group-hover:translate-x-[-2px] transition-transform duration-200" />
      {text}
    </button>
  );
};

export default BackButton;
